
import utils from '@/components/pages/guests/mixins/utils'

export default {
    mixins: [utils],

    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },

        guest: {
            type: Object,
            default: () => {
                return {}
            },
        },

        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            labels: ['Attending', "Can't Attend"],
            newGuest: {
                first_name: null,
                last_name: null,
                parent_id: this.guest.id,
            },
            isNew: false,
        }
    },

    computed: {
        computedEvent() {
            return this.model?.wedding_events?.length ? this.model.wedding_events.find((el) => el.id === this.event.id) : this.event
        },

        getStatus() {
            return this.model?.id ? (this.computedEvent.status === 3 ? true : this.computedEvent.status === 1 ? false : null) : null
        },

        selectedMealOption() {
            if (this.model?.id) {
                let selectedMealOptions = null
                try {
                    selectedMealOptions = JSON.parse(this.computedEvent.selected_meal_options)
                } catch (error) {
                    selectedMealOptions = this.computedEvent.selected_meal_options?.length || null
                }
                return selectedMealOptions ? selectedMealOptions[0] : null
            }
            return null
        },

        showMealOptions() {
            return this.model?.id && this.computedEvent?.status === 3 && this.computedEvent.meal_options?.length
        },

        switchDisabled() {
            return !this.model || !this.model.id ? !this.newGuest.first_name || !this.newGuest.last_name : false
        },

        isPlusOne() {
            return this.model?.id !== this.guest?.id
        },

        children() {
            return this.guest?.children?.length
                ? this.guest.children
                      .filter(
                          (guest) => guest.wedding_events.findIndex((event) => event.id === this.event.id && !event.status) !== -1 || guest.id === this.model.id
                      )
                      .map((guest) => {
                          return { ...guest, name: this.getFormattedName(guest) }
                      })
                : []
        },
    },

    watch: {
        model: {
            handler() {
                if (this.model?.id)
                    this.newGuest = {
                        first_name: this.model?.first_name,
                        last_name: this.model?.last_name,
                        parent_id: this.guest.id,
                    }
            },
            immediate: true,
        },
    },

    methods: {
        saveGuestInfo(data, model = null) {
            return new Promise((resolve) => {
                const computedModel = model || this.model
                if (!computedModel || !computedModel.id) {
                    this.$emit('reduce-event-count')
                    return
                }
                this.$axios.$put(`/api/v1/public/guests/${computedModel.id}/guest_wedding_events/${this.computedEvent.id}/status`, data).then((res) => {
                    this.$nextTick(() => this.$emit('updated', { guest: computedModel, event: res.data }))
                    resolve()
                })
            })
        },

        saveNewGuest() {
            if (this.newGuest.first_name && this.newGuest.last_name) {
                if (this.model?.id)
                    this.$axios.$put(`/api/v1/public/guests/${this.model.invite_id}`, { ...this.model, ...this.newGuest }).then((res) => {
                        this.doAfterSave(res.data)
                    })
                else
                    this.$axios.$post(`/api/v1/public/guests/${this.$route.params.username}`, this.newGuest).then((res) => {
                        this.doAfterSave(res.data)
                    })
            }
        },

        doAfterSave(data) {
            this.newGuest = {
                first_name: this.model?.first_name || null,
                last_name: this.model?.last_name || null,
                parent_id: this.guest.id,
            }

            this.$emit('edit-guest', data)
            this.$nextTick(() => this.saveGuestInfo({ status: this.model?.id ? this.computedEvent.status || 2 : 2 }, data))
        },

        setGuest(guest) {
            const model = this.children.find((el) => el.id === parseInt(guest?.id || 0))
            if (model?.id) {
                this.saveGuestInfo({ status: 2 }, model).then(() => {
                    if (this.model?.id) this.saveGuestInfo({ status: 0 }, this.model)
                })
            }
        },

        removeGuest() {
            this.saveGuestInfo({ status: 0 }, this.model)
        },

        setStatus(val) {
            const params = { status: val ? 3 : 1 }
            if (!val) {
                params.selected_meal_options = []
                params.answers = []

                if (!this.isPlusOne) this.guest.children.map((guest) => this.saveGuestInfo(params, { guest, skip_klaviyo: true }))
            }

            this.saveGuestInfo(params)
        },
    },
}
